import type { Animal } from 'shared/@generated/models';

export function resolveAdAnimal({
  animal,
  breedIds,
  breeds = [],
}: {
  animal?: Animal | null;
  breedIds?: readonly (number | string)[] | null;
  breeds?: readonly { id: number; animal: Animal }[];
}): Animal | null {
  if (animal) return animal;
  if (!breedIds?.length) return null;

  const selectedAnimals = breedIds.map(
    (id) => breeds.find((breed) => String(breed.id) === String(id))?.animal,
  );
  const firstAnimal = selectedAnimals[0];

  return firstAnimal && selectedAnimals.every((value) => value === firstAnimal)
    ? firstAnimal
    : null;
}
